import { Button, Input, Select, Space, Form, Typography } from "antd";
import { useEffect } from "react";
import { useState } from "react";
import { useCaregivers } from "../../api/Caregivers";
import CaregiverRow from "../../components/CaregiverDisplay/CaregiverRow";
import Loading from "../../components/Loading";
import SubmitButton from "../../components/SubmitButton";
import SidebarLayout from "../../layout/SidebarLayout";
import { ageSelectOptions } from "../../utils/ageGroupOptions";
import careCategoryOptions, {
  careCategorySelectOptions,
} from "../../utils/careCategoryOptions";
import { daySelectOptions } from "../../utils/dayUtils";
import { useUserFavorites } from "../../api/Favorites";
import { useSearchParams } from "react-router-dom";

const Caregivers = () => {
  const [searchParams] = useSearchParams();
  const [nextToken, setNextToken] = useState();
  const [params, setParams] = useState();
  const { data, isLoading, isRefetching } = useCaregivers(params);
  const { data: favoriteCaregivers } = useUserFavorites({
    category: "caregiver",
  });

  useEffect(() => {
    let filters = {};
    for (let entry of searchParams.entries()) {
      filters[entry[0]] = entry[1];
    }
    setParams(filters);
  }, [searchParams]);

  useEffect(() => {
    if (nextToken) {
      setParams({ ...searchParams, ...{ next: nextToken } });
    }
  }, [nextToken]);

  return (
    <>
      <SidebarLayout.Sidebar>
        <CaregiverSearch onSearch={setParams} initialParams={params} />
      </SidebarLayout.Sidebar>
      <SidebarLayout.Content>
        {isLoading || isRefetching ? (
          <Loading />
        ) : (
          <>
            {data?.Users?.map((u) => (
              <CaregiverRow
                key={u?.UserId}
                caregiver={u}
                favorites={favoriteCaregivers?.favorites}
              />
            ))}
            {data?.NextPage && (
              <div style={{ padding: "50px", textAlign: "center" }}>
                <Button
                  onClick={() => {
                    setNextToken(data.NextPage);
                  }}
                >
                  Load More
                </Button>
              </div>
            )}
            {data?.Users?.length === 0 && (
              <div style={{ padding: 20, textAlign: "center" }}>
                <Typography.Title level={2}>
                  No providers matched your search!
                </Typography.Title>
              </div>
            )}
          </>
        )}
      </SidebarLayout.Content>
    </>
  );
};

const CaregiverSearch = ({ onSearch, initialParams }) => {
  const [careType, setCareType] = useState();
  const [form] = Form.useForm();

  const submit = (values) => {
    let filters = {};
    Object.keys(values).forEach((v) => {
      let value = values[v];
      if (value) filters[v] = value;
    });
    onSearch(filters);
  };

  const reset = () => {
    form.resetFields();
    onSearch({});
  };

  const careOptions = careCategorySelectOptions();

  return (
    <Form
      form={form}
      style={{ marginBottom: "15px" }}
      layout="vertical"
      onFinish={submit}
      initialValues={{
        caretype: initialParams?.caretype || "",
        category: "",
        availability: "",
        age: "",
      }}
    >
      <Form.Item name="caretype" label="Service Type">
        <Select options={careOptions} onChange={(e) => setCareType(e)} />
      </Form.Item>
      <Form.Item name="category" label="Category">
        <Select options={careCategoryOptions(true, careType)} />
      </Form.Item>
      <Form.Item name="availability" label="Availability">
        <Select options={daySelectOptions()} />
      </Form.Item>
      <Form.Item name="age" label="Age">
        <Select options={ageSelectOptions()} />
      </Form.Item>
      <Form.Item name="name" label="Caregiver Name">
        <Input placeholder="First Name" />
      </Form.Item>
      <Form.Item>
        <Space direction="vertical" style={{ width: "100%" }}>
          <SubmitButton block size="large">
            Search
          </SubmitButton>
          <Button
            type="text"
            block
            onClick={() => {
              reset();
            }}
          >
            Clear
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default Caregivers;
